import type { ConfigType } from '@plone/registry';
import Card from '../components/Card/Card';
import ListView from '../components/Blocks/SolarSearch/ListView';
import * as ResultItems from '@fhnw/components/GlobalSearch/ResultItems';

/**
 * Configure components and component registrations
 * Follows SOLID principles by separating component configuration concerns
 */
export const configureComponents = (config: ConfigType) => {
  // Global search result views
  config.views.globalContentTypeSearchResultViews = {
    Default: ResultItems.DefaultGlobalSearchResultItem,
  };

  // Search block result item components
  config.registerComponent({
    name: 'searchBlockResultItem',
    component: Card,
    dependencies: ['News Item', 'Default'],
  });

  config.registerComponent({
    name: 'searchBlockResultItem',
    component: ListView,
    dependencies: ['News Item', 'List'],
  });

  config.registerComponent({
    name: 'searchBlockResultItem',
    component: Card,
    dependencies: ['Event', 'Default'],
  });

  config.registerComponent({
    name: 'searchBlockResultItem',
    component: ListView,
    dependencies: ['Event', 'List'],
  });

  config.registerComponent({
    name: 'searchBlockResultItem',
    component: Card,
    dependencies: ['Course', 'Default'],
  });

  config.registerComponent({
    name: 'searchBlockResultItem',
    component: ListView,
    dependencies: ['Course', 'List'],
  });

  return config;
};
